import React from 'react';
import style from './Body.css';

const Body = () => {
    return (
        <div className={style.bodyOuterDiv}>
            <div className={style.textBox}>
                <p>
                hey
                <br></br>
                <br></br>
                my site is still under construction 😁
                <br></br>
                feel free to check out the links up top!
                </p>
            </div>
        </div>
    )
}

export default Body
